// extracted by mini-css-extract-plugin
export var attribution = "_bk-4";
export var authorName = "_bk-5";
export var quote = "_bk-3";
export var testimonial = "_bk-2";
export var trustedBy = "_bk-0";
export var trustedByLabel = "_bk-1";